import React, { useId } from 'react'
import PropTypes from 'prop-types'

const GearIcon = React.forwardRef(function GearIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"></path>
        <path d="M24 12C24 10.35 22.65 9 21 9H19.25L20.52 7.76C21.09 7.19 21.4 6.44 21.4 5.64C21.4 4.84 21.09 4.08 20.52 3.52C19.35 2.35 17.44 2.35 16.27 3.52L15.02 4.77V3C15.02 1.35 13.67 0 12.02 0C10.37 0 9.02 1.35 9.02 3V4.76L7.77 3.51C6.6 2.34 4.7 2.34 3.52 3.51C2.95 4.08 2.64 4.83 2.64 5.64C2.64 6.44 2.95 7.19 3.52 7.76L4.76 9H3C1.34 9 0 10.35 0 12C0 13.65 1.35 15 3 15H4.76L3.52 16.24C2.95 16.81 2.64 17.56 2.64 18.36C2.64 19.16 2.95 19.92 3.52 20.48C4.69 21.65 6.59 21.65 7.77 20.48L9.02 19.23V21C9.02 22.65 10.37 24 12.02 24C13.67 24 15.02 22.65 15.02 21V19.25L16.24 20.49C17.41 21.66 19.31 21.66 20.49 20.49C21.06 19.92 21.37 19.17 21.37 18.37C21.37 17.57 21.06 16.82 20.49 16.25L19.24 15H21C22.65 15 24 13.65 24 12ZM17.53 16.12L19.07 17.66C19.26 17.85 19.36 18.1 19.36 18.37C19.36 18.64 19.26 18.89 19.07 19.08C18.68 19.47 18.04 19.47 17.66 19.09L16.14 17.55C15.79 17.21 15.34 17.02 14.85 17.02C13.84 17.02 13.02 17.84 13.02 18.85V21C13.02 21.55 12.57 22 12.02 22C11.47 22 11.02 21.55 11.02 21V18.83C11.02 17.82 10.2 17 9.19 17C8.7 17 8.24 17.19 7.9 17.53L6.36 19.07C5.97 19.46 5.33 19.46 4.94 19.07C4.75 18.88 4.65 18.63 4.65 18.36C4.65 18.09 4.75 17.84 4.94 17.65L6.48 16.11C6.82 15.76 7.01 15.31 7.01 14.82C7.01 13.81 6.19 12.99 5.18 12.99H3C2.45 12.99 2 12.54 2 11.99C2 11.44 2.45 10.99 3 10.99H5.18C6.19 10.99 7.01 10.17 7.01 9.16C7.01 8.67 6.82 8.21 6.47 7.87L4.93 6.34C4.74 6.15 4.64 5.9 4.64 5.64C4.64 5.37 4.74 5.12 4.93 4.93C5.32 4.54 5.96 4.54 6.35 4.93L7.89 6.47C8.24 6.81 8.7 7 9.18 7C10.19 7 11.01 6.18 11.01 5.17V3C11.01 2.45 11.46 2 12.01 2C12.56 2 13.01 2.45 13.01 3V5.17C13.01 6.18 13.83 7 14.84 7C15.33 7 15.79 6.81 16.13 6.47L17.67 4.93C18.06 4.54 18.7 4.54 19.09 4.93C19.28 5.12 19.38 5.37 19.38 5.64C19.38 5.91 19.28 6.15 19.09 6.34L17.52 7.88C17.18 8.23 16.99 8.68 16.99 9.17C16.99 10.18 17.81 11 18.82 11H21C21.55 11 22 11.45 22 12C22 12.55 21.55 13 21 13H18.82C17.81 13 16.99 13.82 16.99 14.83C16.99 15.31 17.18 15.77 17.53 16.12Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

GearIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

GearIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default GearIcon
